import React, { 
    useState, 
    useEffect  
  } from 'react';
  
import Navbar from '../../Components/Navbar/Navbar';
import dayjs from 'dayjs';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Space,
    Modal,
    Input,
    Table,
    Menu,
    Dropdown,
    Tabs,
    DatePicker,
} from 'antd';
import { 
    ProductOutlined,
    ExclamationCircleFilled 
} from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'; 
import { usePostRequest } from '../../hooks/usePostRequest';
import { 
    useNavigate, 
} from "react-router-dom";
import { formatDate, getTodayDateISO, TypeTag } from '../../Utils/Common';
import BtnExcel from '../../Components/BtnExcel';
  
const { Search } = Input;
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
  
const Payment = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [reason, setReason] = useState("");
    const [rowId, setRowId] = useState("");
    const [isModalReason, setIsModalReason] = useState(false);
    const [paymentData, setPaymentData] = useState([]);
    const startDate = dayjs().startOf('month');
    const endDate = dayjs().endOf('month');
    const [filterConfig, setFilterConfig] = useState({
        term: '',
        check_status: 'all',
        payment_date_from: dayjs(startDate).format('YYYY-MM-DD'),
        payment_date_to: dayjs(endDate).format('YYYY-MM-DD'),
    });
    const [excelData, setExcelData] = useState([]);
    const { callPost, loading } = usePostRequest(()=>{
        fetchPaymentData();
        setIsModalReason(false);
        setReason("");
        setRowId("")
    });

    const customSpinner = <ProductOutlined style={{ fontSize: 24, color: "#005E30"  }} spin />;

    const columns = [
        {
            title: 'Payment ID',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
        }, 
        {
            title: 'SA #',
            dataIndex: 'sa_numbers',
            key: 'sa_numbers',
            align: 'center',
        },
        {
            title: 'Member Name',
            dataIndex: 'member_name',
            key: 'member_name',
            align: 'center',
        }, 
        {
            title: 'AR Customer ID',
            dataIndex: 'ar_cust_id',
            key: 'ar_cust_id',
            align: 'center',
        },
        {
            title: 'Payment Date',
            dataIndex: 'payment_date',
            key: 'payment_date',
            align: 'center',
        },
        {
            title: 'OR Number',
            dataIndex: 'or_no',
            key: 'or_no',
            align: 'center',
            render: (value) => value ?? '—',
        },
        {
            title: 'Payment Type',
            dataIndex: 'mop',
            key: 'mop',
            align: 'center',
            render: (_, record) => (
                <>
                    <Row className='mb-2'>
                        <Col span={24}>
                            <strong>{TypeTag(record.mop)}</strong>
                        </Col>
                    </Row>
                    <Row>
                        <Col align="left">
                            {
                                record.mop === "check" ? (
                                    <>
                                        <div>Bank Name: <strong>{record.bank_name}</strong></div>
                                        <div>Check Date: <strong>{record.check_date}</strong></div>
                                        <div>Check No#: <strong>{record.check_no}</strong></div>
                                        <div>Check Status: <strong>{record.check_status}</strong></div>
                                    </>
                                ) : record.mop === "credit_card" ? (
                                    <>
                                        <div>Bank Name: <strong>{record.bank_name}</strong></div>
                                        <div>Approval Code: <strong>{record.approval_code}</strong></div>
                                    </>
                                ) : record.mop === "direct_deposit" ? (
                                    <>
                                        <div>Bank Name: <strong>{record.bank_name}</strong></div>
                                        <div>Customer ID: <strong>{record.customer_id}</strong></div>
                                    </>
                                ) : record.mop === "gcash" ? (
                                    <div>Reference Number: <strong>{record.reference_no}</strong></div>
                                ) : null
                            }
                        </Col>
                    </Row>
                </>
            ),
            // render: (type) => TypeTag(type)
        },
        {
            title: 'Added By',
            dataIndex: 'added_by_user',
            key: 'added_by_user',
            align: 'center',
        },
        ...(filterConfig.check_status === "cancelled"
            ? [
                  {
                      title: "Voided By",
                      dataIndex: "voided_by_user",
                      key: "voided_by_user",
                      align: "center",
                  },
                  {
                      title: "Approved By",
                      dataIndex: "approved_by_user",
                      key: "approved_by_user",
                      align: "center",
                  },
              ]
            : []
        ),
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            align: 'center',
            width: '5%',
            render: (_, record) => (
                <ActionBtn row={record} />
            ),
        },
    ];


    function ActionBtn(row) {
        const menu = (
            <Menu>
                
                <Menu.Item 
                    onClick={() => navigate('/accounting/view-payment/' + row.row.id)}
                >
                    View
                </Menu.Item>
                
                {
                    (row.row.mop === "check" && row.row.check_status !== "for_cancellation" && row.row.check_status !== "cancelled") && (
                        <Menu.Item 
                            key="delete"
                            style={{color: 'red'}}
                            onClick={() => {
                                setRowId(row.row.id);
                                setIsModalReason(true);
                            }}
                        >
                            Void
                        </Menu.Item>
                    )
                }
                {
                    (filterConfig?.check_status === "for_cancellation") && (
                        <>
                            <Menu.Item 
                                key="approve"
                                style={{color: 'green'}}
                                onClick={() => handleChangeStatus("cancelled",row.row.id)}
                            >
                                Approved
                            </Menu.Item>
                            <Menu.Item 
                                key="disapprove"
                                style={{color: 'red'}}
                                onClick={() => handleChangeStatus("disapproved",row.row.id)}
                            >
                                Disapproved
                            </Menu.Item>
                        </>
                    )
                }
            </Menu>
        );

        return (
            <>
                <span className='center'>
                    <Dropdown
                        overlay={menu} 
                        placement="bottomLeft"
                        trigger={['click']}
                    >
                    <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
                        <Space>
                        <MoreVert />
                        </Space>
                    </div>
                    </Dropdown>
                </span>
            </>
        );
    };
  
    async function fetchPaymentData() {
      setIsLoading(true);
      const response = await UseGetRequest("billing_payments/get_billing_payment", 
        filterConfig.check_status === "all" ? {
            payment_date_from: filterConfig.payment_date_from,
            payment_date_to: filterConfig.payment_date_to,
        } : {
            ...filterConfig
        }
    );
      if (response?.data) {
        const table_data = response?.data?.payments?.map((data) => ({
            ...data,
            sa_numbers: [...new Set((data.billing_payments || [])
                .map((item) => item.billing_id)
                .filter((id) => id != null)
                .map(String))].join(', ') || '—',
            payment_date: formatDate(data.payment_date),
            check_date: formatDate(data.check_date),
        }));
        setPaymentData(table_data);
        const excel_data = response?.data?.payments?.map((data) => ({
            id: data.id,
            sa_numbers: [...new Set((data.billing_payments || [])
                .map((item) => item.billing_id)
                .filter((id) => id != null)
                .map(String))].join(', ') || '—',
            member_name: data.member_name,
            ar_cust_id: data.ar_cust_id,
            mop: data.mop,
            payment_date: formatDate(data.payment_date),
            or_no: data.or_no ?? '',
            added_by_user: data.added_by_user,
            voided_by_user: data.voided_by_user,
            approved_by_user: data.approved_by_user,
        }));
        setExcelData(excel_data);
      } else {
        setPaymentData([]);
        setExcelData([]);
      }
      setIsLoading(false);
    }

    const handleChangeStatus = (status, id) => {
        callPost(
            "billing_payments/change_status", 
            {check_status: status, payment_id: id},
            false,
        ); 
    };

    const handleTableChange = (pagination) => {
      setFilterConfig((prev) => ({
        ...prev,
        page: parseInt(pagination.current),
        page_size: pagination.pageSize,
      }));
    };

    const handleChange = (e) => {
        setFilterConfig((prev) => (
          {
            ...prev,
            term: e || '',
            page: 1,
          }
        ));
    };
      
    const handleEmpty = (e) => {
        if(e.target.value === ''){
          setFilterConfig((prev) => (
            {
              ...prev,
              term: e.target.value || '',
              page: 1,
            }
          ));
        }
    };

    const onChange = (activeKey) => {
        setFilterConfig((prev) => (
            {
                ...prev,
                check_status:  activeKey,
            }
        ));
    };

    const onSearchDate = (e) => {
        if(e){
            setFilterConfig((prev) => (
                {
                  ...prev,
                  payment_date_from: e[0].format("YYYY-MM-DD"),
                  payment_date_to: e[1].format("YYYY-MM-DD"),
                  page: 1,
                }
            ));
        } else {
            setFilterConfig((prev) => (
                {
                  ...prev,
                  payment_date_from: "",
                  payment_date_to: "",
                  page: 1,
                }
            ));
        }
    };
      
    useEffect(() => {
        fetchPaymentData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterConfig]);
    
    return (
        <Layout className='page'>
            <Navbar navKey={'credit_payment'}/>
            <Layout className='content-container overflow-y'>
                <Row className='custom-padding responsive-tab-inline'>
                    <Col span={15} className='header-container'>
                        PAYMENTS
                    </Col>
                    <Col span={9} className='mt-2 responsive-tab-width' align='end'>
                        <Space className='responsive-inline'> 
                            <Search
                                placeholder="Search Payment"
                                size='medium'
                                onSearch={(e)=>handleChange(e)}
                                onChange={(e)=>handleEmpty(e)}
                                className='responsive-header-input'
                            />    
                            <BtnExcel
                                label={"Export to Excel"}
                                size={"sm"}
                                excelData={excelData}
                                xlsxHeaders={[
                                    "Payment ID",
                                    "Member Name",
                                    "AR Customer ID",
                                    "Payment Type",
                                    "Payment Date",
                                    "Added By",
                                    "Voided By",
                                    "Approved By",
                                ]}
                                handleData={fetchPaymentData}
                                isClicked={isLoading}
                                fileName={`Payment_${getTodayDateISO()}.xlsx`}
                            />            
                            <Button 
                                className='button-color responsive-header-btn' 
                                onClick={() => navigate('/accounting/add-payment')}
                                type="primary"
                            >
                                + Add Payment
                            </Button>         
                        </Space>
                    </Col>
                </Row>
                <Row className='ms-4 responsive-tab-inline'>
                    <Col span={24} className='responsive-tab-width'>
                        <Space span={24}>
                            <RangePicker 
                                renderExtraFooter={() => 'extra footer'} 
                                className='responsive-header-input'
                                value={[
                                    filterConfig?.payment_date_from ? dayjs(filterConfig.payment_date_from) : null,
                                    filterConfig?.payment_date_to ? dayjs(filterConfig.payment_date_to) : null
                                ]}
                                onChange={(e)=>onSearchDate(e)}
                            />
                        </Space>
                    </Col>
                </Row>
                <Row className='page-content'>
                    <Col span={24} className='responsive-overflow-auto'>
                        <Tabs 
                            type="card" 
                            className="custom-tabs"
                            activeKey={filterConfig?.check_status}
                            onChange={onChange}
                        >
                            <TabPane tab="All" key="all">
                                <Table 
                                    columns={columns} 
                                    dataSource={paymentData} 
                                    loading={{
                                    indicator: customSpinner,
                                    spinning: isLoading,
                                    }}
                                    pagination={{
                                    defaultPageSize: 10,
                                    //   total: pageSize,
                                    current: filterConfig?.page,
                                    pageSize: filterConfig?.total_records_per_page,
                                    }}
                                    onChange={handleTableChange}
                                />
                            </TabPane>
                            <TabPane tab="For Cancellation" key="for_cancellation">
                                <Table 
                                    columns={columns} 
                                    dataSource={paymentData} 
                                    loading={{
                                    indicator: customSpinner,
                                    spinning: isLoading,
                                    }}
                                    pagination={{
                                    defaultPageSize: 10,
                                    //   total: pageSize,
                                    current: filterConfig?.page,
                                    pageSize: filterConfig?.total_records_per_page,
                                    }}
                                    onChange={handleTableChange}
                                />
                            </TabPane>
                            <TabPane tab="Cancelled" key="cancelled">
                                <Table 
                                    columns={columns} 
                                    dataSource={paymentData} 
                                    loading={{
                                    indicator: customSpinner,
                                    spinning: isLoading,
                                    }}
                                    pagination={{
                                    defaultPageSize: 10,
                                    //   total: pageSize,
                                    current: filterConfig?.page,
                                    pageSize: filterConfig?.total_records_per_page,
                                    }}
                                    onChange={handleTableChange}
                                />
                            </TabPane>
                            
                        </Tabs>
                    </Col>
                </Row>
                  <Modal
                    title={
                        <>
                            <ExclamationCircleFilled className="red-cont" /> Are you sure you want to void payment?
                        </>
                    }
                    open={isModalReason}
                    footer={null}
                    closable={false}
                    maskClosable={false}
                    loading={loading}
                >
                   <Row className='mb-2'>
                        <div className='mb-2'>This action cannot be undone.</div>
                        <Input
                            placeholder="Enter your reason"
                            value={reason}
                            className='input-reason'
                            onChange={(e) => setReason(e.target.value)}
                        />
                    </Row>
                    <Row className='btn-footer'>
                        <Space>
                            <Button
                                onClick={() => setIsModalReason(false)}
                                className='btn-header'
                            >
                                Cancel
                            </Button>
                        
                            <Button
                                onClick={() => 
                                    callPost(
                                        `billing_payments/change_status`, 
                                        {
                                            check_status: "for_cancellation", 
                                            payment_id: rowId, 
                                            reason: reason
                                        },
                                        false
                                    )
                                }
                                type='primary'
                                loading={loading}
                                className='btn-header'
                                disabled={!reason.trim()}
                            >
                                Save
                            </Button>
                        </Space>
                    </Row>
                </Modal>
            </Layout>
        </Layout>
    )
  }

  export default Payment
